import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f876e0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about_content" }
const _hoisted_2 = { class: "about_header fade-in" }
const _hoisted_3 = { class: "about_close" }
const _hoisted_4 = { class: "about_body" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = {
  id: "escape-path",
  class: "arrow-path",
  width: "49",
  height: "216",
  viewBox: "0 0 49 216",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = { id: "escape-path-mask" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "0",
  width: "49",
  height: "216",
  fill: "white"
}, null, -1))
const _hoisted_9 = { class: "left_title" }
const _hoisted_10 = { class: "left_title_wrapper" }
const _hoisted_11 = { class: "left_title_wrapper" }
const _hoisted_12 = { class: "text_wrapper" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "about_footer fade-in" }
const _hoisted_15 = { class: "about_close" }

import { ref, watch, nextTick } from 'vue'
  import { useI18n } from 'vue-i18n'
  import SimpleScrollbar from 'simple-scrollbar'
  import 'simple-scrollbar/simple-scrollbar.css'
  
  import gsap from 'gsap'
  import { DrawSVGPlugin } from "gsap/DrawSVGPlugin"
  import { MotionPathPlugin } from "gsap/MotionPathPlugin";
  import { useAppState } from '@/services/composition'
  import { Role } from '@/services/states/AppStateMachine'

  import UIBrands from '@/components/UIBrands/UIBrands.vue'

  
export default /*#__PURE__*/_defineComponent({
  props: {
    aboutOptions: Object,
    isAnimationBlocked: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {

const props = __props

  gsap.registerPlugin(DrawSVGPlugin);
  gsap.registerPlugin(MotionPathPlugin);

  const { t } = useI18n()
  const { state } = useAppState()

  const root = ref<HTMLElement>(null)
  const container = ref<HTMLElement>(null)
  const scroller = ref<HTMLElement>(null)
  const noScrollBar = ref(false)

  const escapePathMask = ref(null)
  const escapePathHead = ref(null)
  const escapePathLine = ref(null)
  const escapePathData = ref({
  })

  

  function replaceWithBr(str: string) {
    return str.replace(/\/n/g, "<br />")
  }

  // onMounted(() => {
  //   if (scroller.value) {
  //     // SimpleScrollbar.unbindEl(scroller.value) 
  //     SimpleScrollbar.initEl(scroller.value)
  //   }
  // })

  watch( () => props.aboutOptions, async ({ isOpen }) => {
    await nextTick()
    if(isOpen && scroller.value) {
      SimpleScrollbar.initEl(scroller.value)
      const scrollWidth = getScrollWidth()
      const scrollContainer = scroller.value.querySelector('.ss-content') as HTMLElement;
      if (scrollWidth === 0) {
        scrollContainer.style.width = '100%';
        noScrollBar.value = true;
      }
      setInitialPosition()
    }
  }, { deep: true })

  const getScrollWidth = () => {
    var outer = document.createElement('div');
    var inner = document.createElement('div');
    outer.style.width = inner.style.width = '100%';
    outer.style.overflow = 'scroll';
    document.body.appendChild(outer).appendChild(inner);
    var scroll_width = outer.offsetWidth-inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    return scroll_width;
  }

  const setInitialPosition = () => {
    if(state.value.context.role == Role.Desktop && window.innerWidth > 1350) {
      container.value.style.transformOrigin = 'bottom right'
        const { width, height } = container.value.getBoundingClientRect()
        container.value.style.transform =  `translate()`
        container.value.style.setProperty(
          'transform', `translate(
            ${props.aboutOptions.x - (width / 2)}px,
            ${props.aboutOptions.y - (height / 2)}px
          )`
        )
    } else {
      root.value.style.justifyContent = 'center'
      root.value.style.alignItems = 'center'
    }
  }

  const onEnter = (el: gsap.DOMTarget, onComplete: gsap.Callback) => {
    const isDesktop = state.value.context.role == Role.Desktop  
  
    const $ = gsap.utils.selector(el)
    const path = (escapePathMask.value as SVGPathElement)
    const head = (escapePathHead.value as SVGGElement)

    gsap.set($('#escape-path'), { opacity: 0 })

    const tl = gsap.timeline({ onComplete }).addLabel('escapePath', 0.1)
    tl.fromTo(el, {
      opacity: 0,
    },{
      opacity: 1,
      duration: 0.5,
      ease: "power2.in"
    }, 'start')
    tl.fromTo($('.about_content'), {
      y: 100      
    }, {
      y: 0,
      duration: 1,
      ease: "power1"
    }, 'start')

    if(isDesktop) {
      tl.to($('#escape-path'), {
        opacity: 1,
        duration: 0.8,
        ease: 'power2.inOut'
      }, "escapePath")
      tl.fromTo(path, {
        drawSVG: '0 100%'
      }, {
        drawSVG: '100% 100%',
        duration: 1.2,
        ease: 'quart.inOut'
      }, "escapePath")
      tl.to(head, {
        motionPath: {
          path: path, 
          autoRotate: true,
          align: path,
          alignOrigin: [0.5, 0.5]
        },
        duration: 1.2,
        ease: 'quart.inOut'
      },"escapePath")
    }

    tl.fromTo($('.left_title_wrapper span'), {
      y: 70,
    }, {
      y: 0,
      duration: 0.5,
      ease: "quart.out",
      stagger: isDesktop && 0.1
    }, isDesktop ? "escapePath+=0.6": 0.6)

    tl.fromTo($('.fade-in'), {
      opacity: 0,
    }, {
      opacity: 1,
      duration: 0.6,
      ease: "power2.inOut"
    }, isDesktop ? "escapePath+=0.8": 0.8)
  }

  const onLeave = (el: gsap.DOMTarget, onComplete: gsap.Callback) => {
    gsap.to(el, {
      opacity: 0,
      duration: 0.3,
      ease: "power2.out",
      onComplete
    })
  }


return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_btn_icon = _resolveComponent("ui-btn-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    css: false,
    onEnter: onEnter,
    onLeave: onLeave
  }, {
    default: _withCtx(() => [
      (props.aboutOptions.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "root",
            ref: root,
            class: "about"
          }, [
            _createElementVNode("div", {
              ref_key: "container",
              ref: container,
              class: "about_inner"
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_ui_icon, {
                    class: "logo",
                    name: "logo-brand"
                  }),
                  _createVNode(UIBrands, { class: "brands brands--pause" }),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_ui_btn_icon, {
                      isAnimationBlocked: __props.isAnimationBlocked,
                      variant: "secondary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeAbout'))),
                      class: "icon",
                      name: "crossmark"
                    }, null, 8, ["isAnimationBlocked"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                      _createElementVNode("defs", null, [
                        _createElementVNode("mask", _hoisted_7, [
                          _hoisted_8,
                          _createElementVNode("path", {
                            ref_key: "escapePathMask",
                            ref: escapePathMask,
                            d: "M10 216L10 8L34 8.00003",
                            fill: "none",
                            stroke: "black",
                            "stroke-width": "4"
                          }, null, 512)
                        ])
                      ]),
                      _createElementVNode("path", {
                        ref_key: "escapePathHead",
                        ref: escapePathHead,
                        d: "M44 8.12728L34 1L34 15L44 8.12728Z",
                        fill: "#1A1A1A"
                      }, null, 512),
                      _createElementVNode("path", {
                        ref_key: "escapePathLine",
                        ref: escapePathLine,
                        mask: "url(#escape-path-mask)",
                        d: "M10 216L10 8L34 8.00003",
                        fill: "none",
                        stroke: "#1A1A1A",
                        "stroke-width": "2",
                        "stroke-linejoin": "bevel",
                        "stroke-dasharray": "8 16"
                      }, null, 512)
                    ])),
                    _createElementVNode("h2", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('about.title.line1')), 1)
                      ]),
                      _createElementVNode("span", _hoisted_11, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('about.title.line2')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["text fade-in", { noScrollBar: noScrollBar.value }])
                  }, [
                    _createElementVNode("div", {
                      ref_key: "scroller",
                      ref: scroller,
                      class: "text_inner"
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("p", {
                          class: "text_content",
                          innerHTML: replaceWithBr(_unref(t)('about.content'))
                        }, null, 8, _hoisted_13)
                      ])
                    ], 512)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(UIBrands, { class: "brands brands--loading" })
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_ui_btn_icon, {
                  variant: "secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeAbout'))),
                  class: "icon",
                  name: "crossmark"
                })
              ])
            ], 512)
          ], 512))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})